import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=aa2083ac&scoped=true&"
import script from "./Return.vue?vue&type=script&lang=ts&"
export * from "./Return.vue?vue&type=script&lang=ts&"
import style0 from "./Return.vue?vue&type=style&index=0&id=aa2083ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2083ac",
  null
  
)

export default component.exports